module.exports = __webpack_public_path__ + "static/media/os.a6f56233.png";